import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-sent-dialog',
  templateUrl: './sent-dialog.component.html',
  styleUrls: ['./sent-dialog.component.scss']
})
export class SentDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<SentDialogComponent>,
    private router: Router
  ) { }

  public send(): void {
    this.router.navigate(['/tracing'], { queryParams: { tab: 1 } });
    this.dialogRef.close();
  }
}
